import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import axios from "axios";
import noimg from "../noimg-bg.jpg";
import "./Post.css";
import Videolink from "./Videolink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlayCircle } from "@fortawesome/free-solid-svg-icons";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";

const Post = props => {
  const [image, setImage] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const getImage = () => {
    const mediaUrl =
      "http://admin.kapoff.se/wp-json/wp/v2/media/" + props.media;
    axios
      .get(mediaUrl)
      .then(res => {
        setImage(res.data.media_details.sizes.large.source_url);
        setIsLoaded(true);
      })
      .catch(err => {
        setIsLoaded(false);
      });
  };

  useEffect(() => {
    getImage();
  }, []);

  const { title, meta, term } = props;
  let imageUrl = "url(" + noimg + ")";
  if (isLoaded && image.length > 1) {
    imageUrl = "url(" + image + ")";
  }
  let articleStyle = {
    backgroundImage: imageUrl
  };

  return (
    <Col xs="12">
      <article className="portfolio" style={articleStyle}>
        <header>
          <h4 dangerouslySetInnerHTML={{ __html: title }}></h4>

          <ul className="categories hList">
            {term.map((category, index) => (
              <li
                key={index}
                dangerouslySetInnerHTML={{ __html: category.name }}
              />
            ))}
          </ul>

          <section className="moreInfo">
            <ul className="productionInfo hList">
              <li className="title">{meta.production}</li>
              <li>{meta.year}</li>
            </ul>

            <ul className="cast">
              {meta.teamRepeater.map((cast, index) => (
                <li key={index}>
                  <span
                    className="title"
                    dangerouslySetInnerHTML={{ __html: cast.title }}
                  />{" "}
                  <span
                    className="name"
                    dangerouslySetInnerHTML={{ __html: cast.name }}
                  />
                </li>
              ))}
            </ul>

            {meta.awardRepeater.length > 1 && (
              <ul className="awards">
                <label>Awards</label>
                {meta.awardRepeater.map(award => (
                  <li key={meta.awardRepeater.indexOf(award)}>
                    <span
                      className="title"
                      dangerouslySetInnerHTML={{ __html: award.host }}
                    />{" "}
                    <span
                      className="name"
                      dangerouslySetInnerHTML={{ __html: award.award }}
                    />
                  </li>
                ))}
              </ul>
            )}

            <ul className="links">
              <Videolink link={meta.videoLink}>
                <li>
                  <FontAwesomeIcon icon={faPlayCircle} /> {meta.videoTitle}
                </li>
              </Videolink>

              {meta.linkURL && (
                <li>
                  <a href={meta.linkURL} target="_blank">
                    <FontAwesomeIcon icon={faExternalLinkAlt} />{" "}
                    {meta.linkTitle}
                  </a>
                </li>
              )}
            </ul>
          </section>
        </header>
      </article>
    </Col>
  );
};

export default Post;



// WEBPACK FOOTER //
// ./src/components/Post.jsx